document.addEventListener('DOMContentLoaded', async function () {
  try {
    const discountSource = {
      purchase_source: 'web'
      
    };

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'discount_source': JSON.stringify(discountSource)
        }
      })
    });

    // console.log('Cart attributes güncellendi:', discountSource);
  } catch (error) {
    console.error('Cart attributes güncelleme hatası:', error);
  }
});